import { IconContent } from '@icons';

export const reportsFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M5 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H5Zm4 4V6H7v1h2Zm5 0V6h-4v1h4Zm2 2.5v-1h-6v1h6ZM14.5 11v1H10v-1h4.5ZM13 14.5v-1h-3v1h3ZM12 16v1h-2v-1h2ZM9 8.5v1H7v-1h2ZM9 12v-1H7v1h2Zm0 1.5v1H7v-1h2ZM9 17v-1H7v1h2Z" />',
};
